export default "__VITE_ASSET__DsR4LrJb__"